import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { VersionInfoService } from './version-info.service';


@Injectable({
  providedIn: 'root',
})
export class ForceRefreshService {
  constructor(private _versionInfoService: VersionInfoService) {}

  private _lastReloadTime: Date;
  markAppReloaded(): void {
    this._lastReloadTime = new Date();
  }

  isReloadRequired(): Observable<boolean> {
    // A failing call must count as "no restart info", not kill reload detection.
    return this._versionInfoService.getWithoutId().pipe(
      catchError(() => of(null)),
      map(version => {
        const latestRestart = version?.lastRestartDateTime;
        if (!latestRestart) {
          return false;
        }

        return !this._lastReloadTime || this._lastReloadTime < latestRestart;
      })
    );
  }

  reloadIfRequired(): void {
    this.isReloadRequired().subscribe(value => {
      if (value) {
        window.location.reload();
      }
    });
  }
}
